// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__2x4jq","top":"Placeholder_top__2V21M","bottom":"Placeholder_bottom__3TKyC"};